if (__SHOULD_POLYFILL_REQUESTIDLECALLBACK__) {
  if (!window.requestIdleCallback) {
    // polyfill (almost) for Safari
    window.requestIdleCallback = (callback: IdleRequestCallback, options?: IdleRequestOptions): number =>
      setTimeout(callback, options?.timeout)
    window.cancelIdleCallback = (handle: number) => clearTimeout(handle)
  }
}
